import './watch-video.component.pug'
import './watch-video.component.scss'

if (!document.documentElement.classList.contains('touchevents')) {
  document.querySelectorAll('.watch-video').forEach((root) => {
    import(
      /* webpackChunkName: "interactiveFabric" */ '../../application/interactiveFabric'
    ).then(({ ScrollMagic, TweenLite }) => {
      const heading = root.querySelector('.heading-jumbo')
      const videoEl = root.querySelector('video')
      const mask = root.querySelector('.watch-video__poster-mask')

      const controller = new ScrollMagic.Controller()

      const scene = new ScrollMagic.Scene({
        offset: -350,
        duration: '130%',
        triggerElement: root
      }).addTo(controller)

      scene.on('enter', async function () {
        if (process.env.NODE_ENV === 'production') {
          await videoEl.play()
        }
        mask.classList.add('unmasked')
        heading.classList.add('showed')
        setTimeout(function(){heading.classList.remove('showed')},4000);
      })

      scene.on('leave', async function (event) {
        await videoEl.pause()
        if (event.state === 'BEFORE' && event.scrollDirection === 'REVERSE') {
          mask.classList.remove('unmasked')
          heading.classList.remove('showed')
        }
      })

      root.addEventListener('click', async () => {
        await videoEl.pause()
      })

      let clientX = -100
      let clientY = -100
      const innerCursor = root.querySelector('.watch-video__button')

      if (innerCursor) {
        root.addEventListener('mousemove', (e) => {
          clientX = e.clientX
          clientY = e.clientY
          TweenLite.to(
            innerCursor,
            {
              translateX: clientX,
              translateY: clientY
            },
            0
          )
        })
        root.addEventListener('mouseenter', function () {
          innerCursor.classList.remove('hidden')
        })
        root.addEventListener('mouseleave', function () {
          innerCursor.classList.add('hidden')
        })
      }
    })
  })
  
  document.querySelectorAll('.videocta').forEach((root) => {
    import(
      /* webpackChunkName: "interactiveFabric" */ '../../application/interactiveFabric'
    ).then(({ ScrollMagic, TweenLite }) => {

      let clientX = -100
      let clientY = -100
      const innerCursor = root.querySelector('.watch-video__button')

      if (innerCursor) {
        root.addEventListener('mousemove', (e) => {
          clientX = e.clientX
          clientY = e.clientY
          TweenLite.to(
            innerCursor,
            {
              translateX: clientX,
              translateY: clientY
            },
            0
          )
        })
        root.addEventListener('mouseenter', function () {
          innerCursor.classList.remove('hidden')
        })
        root.addEventListener('mouseleave', function () {
          innerCursor.classList.add('hidden')
        })
      }
    })
  })
}
